<template>
  <v-list-item class="pa-0">
    <v-card class="pa-4">
      <v-card-title class="headline">Статистика sip статусов</v-card-title>
      <v-card-text>Актуальная информация на данный момент:
        <p class="mb-0" v-if="infoSip.doorphones_count">Кол-во домофонов: {{ infoSip.doorphones_count }}</p>
        <p class="mb-0" v-if="infoSip.sip_status_0">Отключено: {{ infoSip.sip_status_0 }}</p>
        <p class="mb-0" v-if="infoSip.sip_status_1">Регистрация: {{ infoSip.sip_status_1 }}</p>
        <p class="mb-0" v-if="infoSip.sip_status_2">Зарегистрировано: {{ infoSip.sip_status_2 }}</p>
        <p class="mb-0" v-if="infoSip.sip_status_3">Не удалось зарегистрироваться: {{ infoSip.sip_status_3 }}</p>
        <p class="mb-0" v-if="infoSip.sip_status_-1">Не зарегистрировано: {{ infoSip.sip_status_-1 }}</p>
        <p class="mb-0" v-if="infoSip.sip_status_null">Не в сети: {{ infoSip.sip_status_null }}</p>
      </v-card-text>
      <v-spacer></v-spacer>
      <v-data-table
        class="table mt-4"
        :headers="headersLogs"
        :items="logsStatistics"
        :options.sync="OptionsLogs"
        :footer-props="{
            'items-per-page-options': [5, 15, 50, -1],
          }"
        disable-sort
      >
        <template v-slot:item.timeInterval="{ item }">
          {{ ruDateFormat(item.time_interval) }}
        </template>
        <template v-slot:item.logsStatus="{ item }">
          <div>
            <p class="mb-0" v-if="item.sip_status_0">Отключен</p>
            <p class="mb-0" v-if="item.sip_status_1">Регистрация</p>
            <p class="mb-0" v-if="item.sip_status_2">Зарегистрирован</p>
            <p class="mb-0" v-if="item.sip_status_3">Не удалось зарегистрироваться</p>
            <p class="mb-0" v-if="item.sip_status_null">Не в сети</p>
          </div>
        </template>
      </v-data-table>
      <v-card-title class="headline">Просмотр логов изменений sip статуса</v-card-title>
      <v-spacer></v-spacer>
      <v-data-table
        class="table mt-4"
        :headers="headersLogsSip"
        :items="logs"
        :options.sync="Options"
        :footer-props="{
            'items-per-page-options': [10, 20, 50, -1],
          }"
        disable-sort
      >
        <template v-slot:item.address="{ item }">
          <div>
            {{ `${item.address}, п.${item.entrance}` }}
          </div>
        </template>
        <template v-slot:item.newSipStatus="{ item }">
          <div>
            {{ displayLabel(item.new_sip_status) }}
          </div>
        </template>
        <template v-slot:item.oldSipStatus="{ item }">
          <div>
            {{ displayLabel(item.old_sip_status) }}
          </div>
        </template>
        <template v-slot:item.updated="{ item }">
          {{ ruDateFormat(item.updated_at) }}
        </template>
      </v-data-table>
    </v-card>
  </v-list-item>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { SIP_STATUS, headersLogsSip, headersLogs } from '../consts';
import ruDateFormatMixin from '@/mixins/ruDateFormat';

export default {
  name: 'ViewSipStatistics',
  mixins: [ruDateFormatMixin],
  props: ['statistics', 'propsEndTime', 'propsStartTime', 'propsDateSip', 'SipStatusLogs'],
  data () {
    return {
      OptionsLogs: {
        itemsPerPage: 5,
        page: 1,
        sortBy: [],
        sortDesc: [],
      },
      Options: {
        itemsPerPage: 10,
        page: 1,
        sortBy: [],
        sortDesc: [],
      },
      loading: false,
      headersLogs,
      headersLogsSip,
    };
  },
  computed: {
    ...mapGetters({
      logs: 'Doorphone/logs',
      logsStatistics: 'Doorphone/logsStatistics',
    }),
    infoSip () {
      return this.statistics.doorphone_info;
    },
  },
  methods: {
    ...mapActions({
    }),
    displayLabel (item) {
      return SIP_STATUS[item];
    },
  },
};
</script>

<style lang="scss" scoped>
.v-card__text, .v-card__title {
  word-break: normal;
}
</style>
